import React from 'react';
import { useFormState } from 'react-final-form';

import WpButton from 'Wpds/components/button/WpButton';
import WpButtonGroup from 'Wpds/components/button/WpButtonGroup';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  onSubmit(): void;
  onToggleModal(): void;
};

function ButtonsArea({ onSubmit, onToggleModal }: Props) {
  const { submitting, errors } = useFormState();
  const { tr } = useTranslation();

  const errorsExist = !!Object.keys(errors).filter(key => errors[key]).length;

  return (
    <WpButtonGroup>
      <WpButton variant="tertiary" disabled={submitting} onClick={onToggleModal}>
        {tr('perform.common.cancel')}
      </WpButton>

      <WpButton btnType="submit" loading={submitting} disabled={errorsExist} onClick={onSubmit}>
        {tr('perform.modals.create_feedback_ai.create_button')}
      </WpButton>
    </WpButtonGroup>
  );
}

export default ButtonsArea;
